module.exports = __webpack_public_path__ + "img/barty_crouch_jrs_tongue.bb13c16f.jpg";